import React, { useContext, useReducer } from "react";
const launchTestContext = React.createContext();

const initialValue = {
  launchTestData: {},
  reserveTestData: {},
  reserveTestId: "",
  loader: false,
  err: false,
};
const reducer = (state, action) => {
  switch (action.type) {
    case "RUNNING_TEST_DATA": {
      return {
        ...state,
        launchTestData: action.payload,
        err: false,
        loader: false,
      };
    }

    case "RESERVE_TEST_DATA": {
      return {
        ...state,
        reserveTestData: action.payload
      }
    }
    case "RESERVE_TEST_ID": {
      return {
        ...state,
        reserveTestId: action.payload
      }
    }

    case "ERR": {
      return { ...state, err: true, loader: false };
    }
    case "LOADER": {
      return { ...state, loader: true };
    }
    case "RESET": {
      return { ...initialValue };
    }
    default:
      return state;
  }
};

export function LaunchTestProvider(props) {

  const [launchTestC, dispatchLaunchTest] = useReducer(reducer, initialValue);
  return (
    <launchTestContext.Provider
      value={{ launchTestC, dispatchLaunchTest }}
      {...props}
    />
  );
}

export function LaunchTestContext() {
  const context = useContext(launchTestContext);
  if (!context) {
    throw new Error(" Please use the context inside parent scope");
  }
  return context;
}
